import React, { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { 
  LayoutDashboard, 
  Megaphone, 
  Users, 
  FileText, 
  Settings, 
  Sun,
  Zap,
  Menu,
  X
} from "lucide-react";

const navItems = [
  { path: "/admin", icon: LayoutDashboard, label: "Dashboard" },
  { path: "/admin/generator", icon: Megaphone, label: "Ad Generator" },
  { path: "/admin/leads", icon: Users, label: "Leads" },
  { path: "/admin/templates", icon: FileText, label: "Templates" },
  { path: "/admin/settings", icon: Settings, label: "Settings" },
];

export const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-[#F8FAFC]" data-testid="app-layout">
      {/* Mobile Header */}
      <div className="lg:hidden fixed top-0 left-0 right-0 z-50 bg-white border-b border-slate-200 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-[#A94442] flex items-center justify-center">
            <Sun className="w-5 h-5 text-white" />
          </div>
          <span className="font-['Outfit'] font-bold text-slate-900">Ion Solar</span>
        </div>
        <button 
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className="p-2 rounded-lg hover:bg-slate-100"
          data-testid="mobile-menu-btn"
        >
          {sidebarOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div 
          className="lg:hidden fixed inset-0 bg-black/50 z-40"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside 
        className={`fixed lg:static inset-y-0 left-0 z-50 w-64 bg-white border-r border-slate-200 flex flex-col transform transition-transform duration-300 ease-in-out ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
        }`}
        data-testid="sidebar"
      >
        {/* Logo */}
        <div className="p-6 border-b border-slate-100">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-[#A94442] flex items-center justify-center">
              <Sun className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="font-['Outfit'] font-bold text-lg text-slate-900">Ion Solar</h1>
              <p className="text-xs text-slate-500">Ad Generator</p>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-4 space-y-1" data-testid="main-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === "/admin"}
              onClick={() => setSidebarOpen(false)}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all ${
                  isActive
                    ? "bg-[#A94442]/10 text-[#A94442] border-l-3 border-[#A94442]"
                    : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
                }`
              }
              data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
            >
              <item.icon className="w-5 h-5" />
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* Sales Rep Info */}
        <div className="p-4 border-t border-slate-100">
          <div className="bg-gradient-to-br from-[#1A4D2E]/10 to-[#1A4D2E]/5 rounded-xl p-4">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 rounded-full bg-[#A94442] flex items-center justify-center border-2 border-white shadow-md">
                <span className="text-white font-bold text-lg">AF</span>
              </div>
              <div>
                <p className="font-['Outfit'] font-semibold text-slate-900">Anthony F.</p>
                <p className="text-xs text-slate-500">Solar Consultant</p>
              </div>
            </div>
            <div className="flex items-center gap-2 text-xs text-[#1A4D2E]">
              <Zap className="w-3 h-3" />
              <span>Virginia PPA Specialist</span>
            </div>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto pt-14 lg:pt-0" data-testid="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
